import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { buildEditOneOnOneAssignmentPdfPath } from "./paths.ts";

export function useToEditOneOnOneAssignmentPdfScreen() {
  const navigate = useNavigate();

  const toEdit = useCallback(
    (
      level: string,
      userGroupId: string,
      oneOnOneLessonType: string,
      assignmentNumber: number,
      businessEnglishObjective?: string,
    ) => {
      navigate(
        buildEditOneOnOneAssignmentPdfPath(
          level,
          userGroupId,
          oneOnOneLessonType,
          assignmentNumber,
          businessEnglishObjective,
        ),
      );
    },
    [navigate],
  );

  return { toEdit };
}
